module.exports = "<div id=\"page_title\">お知らせ</div>\r\n<div *ngFor=\"let notice of noticeList\">\r\n    <div class=\"card text-white bg-info mb-3 d-block w-100 font-weight-bold\">\r\n        <div class=\"card-header\">{{notice.comp_name}} ({{notice.create_date | date:\"yyyy/MM/dd\"}})</div>\r\n         <div class=\"card-body\">\r\n            <h5 class=\"card-title\">{{notice.title}}</h5>\r\n            <p class=\"card-text m-4\" style=\"white-space: pre-wrap;\">{{notice.content}}</p>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/mobile/notice.component.html
// module id = ./src/app/mobile/notice.component.html
// module chunks = main